module.exports = __webpack_public_path__ + "media/img/frontend_application/eventtype/wedding-5df3d4727a326b94d37e2b62da61fb92.jpg";